module.exports = __webpack_public_path__ + "h5/img/examine.967933cb.png";